import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import MeaButton from "./MeaButton";

const MeaUpdateModal = forwardRef((props, ref) => {
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  //
  const [loading, setLoading] = useState(false);
  //
  const toast = useRef(null);
  //
  const handleUpdateSubmit = async (e) => {
    // Handle update action
    setLoading(true);
    props.serviceAPI
      .UpdateOne(props.schoolId, props.trainingId, props.accessToken, props.id, props.data)
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        setActive(false);
        callbackFn?.();
        //
        if (props.onSubmitted) {
          props.onSubmitted();
        }
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: err.message || "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //
  useImperativeHandle(ref, () => ({
    show: (callback) => {
      setCallbackFn(() => callback);
      setActive(true);
    },
    hide: () => {
      setActive(false);
    }
  }));
  //

  const footerContent = (
    <div className="flex justify-content-between">
      <div>
        {props.footerExtra}
      </div>
      <div></div>
      <div>
        <MeaButton
          label="Annuler"
          icon="pi pi-times"
          disabled={loading}
          onClick={() => setActive(false)}
          className="p-button-text"
        />
        <MeaButton
          type="submit"
          loading={loading}
          label="Enregister"
          icon="pi pi-save"
          onClick={() => handleUpdateSubmit()}
        />
      </div>
    </div>
  );

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        focusOnShow={false}
        header={props.title}
        visible={active}
        style={props.dialogStyle || { width: "30vw" }}
        contentStyle={props.contentStyle || { overflowY: "auto", maxHeight: "70vh" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <div className="w-full">
          <div className="flex flex-column gap-2">{props.children}</div>
        </div>
      </Dialog>
    </>
  );
});

export default MeaUpdateModal;
